export const ADMIN_TOGGLE_MAINTENANCE_MODE = 'maintenance-mode';
export const GITHUB_EMU_AUTH = 'github-emu-auth';
export const GITHUB_EMU_COMBINED = 'github-emu-combined';
